(function () {
  var PP_VARIANT_ID = 49180744614130;
  var KEY_IN_CART = 'fixshape:pp_in_cart';
  var KEY_MANUALLY_REMOVED = 'fixshape:pp_manually_removed';

  var isProcessing = false;
  var isAutoMutating = false;
  var weDispatchedRefresh = false;

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  function ppWasInCart() { return ssGet(KEY_IN_CART) === '1'; }
  function setPPWasInCart(v) { v ? ssSet(KEY_IN_CART, '1') : ssDel(KEY_IN_CART); }
  function ppManuallyRemoved() { return ssGet(KEY_MANUALLY_REMOVED) === '1'; }
  function setPPManuallyRemoved(v) { v ? ssSet(KEY_MANUALLY_REMOVED, '1') : ssDel(KEY_MANUALLY_REMOVED); }

  // ─── DOM: keep PP visually last in cart drawer ────────────────────────────

  function movePPToLastInDOM() {
    var list = document.querySelector('.cart-drawer__line-items');
    if (!list) return;
    var all = list.querySelectorAll('line-item');
    if (all.length < 2) return;
    var pp = list.querySelector('line-item[data-variant-id="' + PP_VARIANT_ID + '"]');
    if (!pp) return;
    if (all[all.length - 1] === pp) return; // already last, do nothing
    list.appendChild(pp); // moves pp to end; triggers observer again, but guard above exits early
  }

  var drawerObserver = new MutationObserver(movePPToLastInDOM);

  function attachObserver() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      drawerObserver.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  // ─── Cart API logic ───────────────────────────────────────────────────────

  function triggerRefresh() {
    if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
    } else {
      weDispatchedRefresh = true;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      weDispatchedRefresh = false;
    }
  }

  async function processCart(cart) {
    if (isProcessing) return;

    var ppItem = cart.items.find(function (i) { return i.variant_id === PP_VARIANT_ID; });
    var regularItems = cart.items.filter(function (i) { return i.variant_id !== PP_VARIANT_ID; });
    var ppIsInCart = !!ppItem;
    var regularCount = regularItems.length;
    var ppIsLast = ppIsInCart && cart.items[cart.items.length - 1].variant_id === PP_VARIANT_ID;

    // Detect manual removal: PP was recorded as in-cart but is now absent, and we didn't remove it
    if (ppWasInCart() && !ppIsInCart && !isAutoMutating) {
      setPPManuallyRemoved(true);
    }

    // Persist current PP presence for next check (survives page reloads — handles cart page reload case)
    setPPWasInCart(ppIsInCart);

    // Empty cart: clear all flags so PP can be auto-added on the next add
    if (cart.item_count === 0) {
      setPPManuallyRemoved(false);
      setPPWasInCart(false);
      return;
    }

    // Only PP remains with no regular items: auto-remove it
    if (regularCount === 0 && ppIsInCart) {
      isProcessing = true;
      isAutoMutating = true;
      try {
        await fetch(Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ppItem.key, quantity: 0 }),
        });
        setPPWasInCart(false);
      } finally {
        isProcessing = false;
        isAutoMutating = false;
      }
      triggerRefresh();
      return;
    }

    // Regular items exist, PP not in cart, customer hasn't manually removed it: auto-add
    if (regularCount > 0 && !ppIsInCart && !ppManuallyRemoved()) {
      isProcessing = true;
      isAutoMutating = true;
      try {
        await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PP_VARIANT_ID, quantity: 1 }),
        });
        setPPWasInCart(true);
      } finally {
        isProcessing = false;
        isAutoMutating = false;
      }
      triggerRefresh();
      return;
    }

    // PP is in cart but not last in Shopify's cart: remove and re-add to push it to the end
    if (ppIsInCart && !ppIsLast) {
      isProcessing = true;
      isAutoMutating = true;
      try {
        await fetch(Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ppItem.key, quantity: 0 }),
        });
        await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PP_VARIANT_ID, quantity: 1 }),
        });
        setPPWasInCart(true);
      } finally {
        isProcessing = false;
        isAutoMutating = false;
      }
      triggerRefresh();
      return;
    }

    // Guard: if PP is somehow duplicated to quantity > 1, correct it
    if (ppIsInCart && ppItem.quantity > 1) {
      isProcessing = true;
      isAutoMutating = true;
      try {
        await fetch(Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ppItem.key, quantity: 1 }),
        });
      } finally {
        isProcessing = false;
        isAutoMutating = false;
      }
      triggerRefresh();
    }
  }

  async function fetchAndProcess() {
    if (isProcessing) return;
    try {
      var cart = await fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      await processCart(cart);
    } catch (e) {}
  }

  // Fired after add-to-cart and line item quantity changes (drawer / product page)
  document.addEventListener('cart:change', async function (event) {
    if (isProcessing) return;
    var cart = event.detail && event.detail.cart;
    if (cart) {
      await processCart(cart);
    } else {
      await fetchAndProcess();
    }
  });

  // Fired on errors or discount changes; also used by us to trigger UI refresh
  // Skip when we fired it ourselves to avoid a redundant fetch
  document.addEventListener('cart:refresh', async function () {
    if (isProcessing || weDispatchedRefresh) return;
    await fetchAndProcess();
  });

  // Handles: initial page load, and cart page reload (cart page reloads instead of firing cart:change)
  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    fetchAndProcess();
  });
})();
